exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "svg path[data-v-307f229a]{fill:#60981b!important}", ""]);

// exports
